import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { buildConfigCode } from "../store/configSlice";
import {
  openDrawer,
  closeDrawer,
  openNitrum,
  toggleBackground,
} from "../store/navSlice";

import "./Nav.scss";

// import ArButton from "./ArButton";
import { ReactComponent as IconCaret } from "../assets/images/caret.svg";
import { ReactComponent as IconEnvironment } from "../assets/images/environment.svg";

// @temp should replace with one standardize SVG
import Frame from "../assets/images/wheelchair/frame.svg";
import SeatSling from "../assets/images/wheelchair/seat-sling.svg";
import Backrest from "../assets/images/wheelchair/backrest.svg";
import Sideguard from "../assets/images/wheelchair/sideguard.svg";
import Footrest from "../assets/images/wheelchair/footrest.svg";
import Casters from "../assets/images/wheelchair/casters.svg";
import RearWheels from "../assets/images/wheelchair/rear-wheels.svg";
import WheelLocks from "../assets/images/wheelchair/wheel-locks.svg";
import Addon from "../assets/images/wheelchair/addon.svg";
import FrameHover from "../assets/images/wheelchair/hover/frame.svg";
import SeatSlingHover from "../assets/images/wheelchair/hover/seat-sling.svg";
import BackrestHover from "../assets/images/wheelchair/hover/backrest.svg";
import SideguardHover from "../assets/images/wheelchair/hover/sideguard.svg";
import FootrestHover from "../assets/images/wheelchair/hover/footrest.svg";
import CastersHover from "../assets/images/wheelchair/hover/casters.svg";
import RearWheelsHover from "../assets/images/wheelchair/hover/rear-wheels.svg";
import WheelLocksHover from "../assets/images/wheelchair/hover/wheel-locks.svg";
import AddonHover from "../assets/images/wheelchair/hover/addon.svg";

const parts = [
  { id: "FRAME", icon: Frame, activeIcon: FrameHover },
  { id: "SEAT_SLING", icon: SeatSling, activeIcon: SeatSlingHover },
  { id: "BACKREST", icon: Backrest, activeIcon: BackrestHover },
  { id: "SIDEGUARDS", icon: Sideguard, activeIcon: SideguardHover },
  { id: "FOOTREST", icon: Footrest, activeIcon: FootrestHover },
  { id: "CASTERS", icon: Casters, activeIcon: CastersHover },
  { id: "REAR_WHEELS", icon: RearWheels, activeIcon: RearWheelsHover },
  { id: "WHEEL_LOCKS", icon: WheelLocks, activeIcon: WheelLocksHover },
  { id: "ADDONS", icon: Addon, activeIcon: AddonHover },
];

function mapState(state) {
  const { activePart, nitrumOpen, backgroundVisible } = state.nav;
  return {
    activePart,
    nitrumOpen,
    backgroundVisible,
  };
}

const mapDispatch = {
  openDrawer,
  closeDrawer,
  openNitrum,
  toggleBackground,
  buildConfigCode,
};

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderWidth: 0,
      sliderContentWidth: 0,
      sliderPrevActive: false,
      sliderNextActive: true,
      selectionIndex: null,
      selectionBoxImmediateTranslation: true,
      selectionBoxLeft: 50,
      selectionBoxSize: {
        w: 0,
        h: 0,
      },
    };

    this.sliderEl = createRef();
    this.firstNavItemEl = createRef();
  }

  componentDidMount() {
    this.calcSliderSize();

    setTimeout(() => {
      this.setSelectionBoxSize();
    }, 1000);

    const onWindowResizeDebounced = this.debounce(
      this.onWindowResize.bind(this),
      100
    );

    window.addEventListener("resize", onWindowResizeDebounced, false);
  }

  componentDidUpdate(prevProps) {
    const part = this.props.activePart;
    const prevPart = prevProps.activePart;

    if (prevPart !== part) {
      this.setState({
        selectionBoxImmediateTranslation: prevPart === null,
      });
    }
  }

  calcSliderSize() {
    const sliderEl = this.sliderEl.current;

    if (sliderEl !== null) {
      this.setState({
        sliderWidth: sliderEl.getBoundingClientRect().width,
        sliderContentWidth: sliderEl.scrollWidth,
      });
    }
  }

  updateSliderControls(event) {
    const { scrollLeft } = event.target;
    const { sliderWidth, sliderContentWidth } = this.state;
    const scrollLimit = sliderContentWidth - sliderWidth - 10;
    this.setState({
      sliderPrevActive: scrollLeft !== 0,
      sliderNextActive: scrollLeft < scrollLimit,
    });
  }

  sliderGoTo(dir) {
    const sliderEl = this.sliderEl.current;

    sliderEl.scrollBy({
      top: 0,
      left: 300 * dir,
      behavior: "smooth",
    });
  }

  onWindowResize() {
    this.setSelectionBoxSize();

    // recalc SelectionBoxLeft
    const sliderEl = this.sliderEl.current;
    const { selectionIndex } = this.state;
    if (sliderEl !== null && selectionIndex !== null) {
      const items = sliderEl.querySelector(".parts-nav").querySelectorAll("li");
      const item = items[this.state.selectionIndex];
      this.setState({
        selectionBoxLeft: item.offsetLeft,
      });
    }
  }

  onSliderPrev() {
    this.sliderGoTo(-1);
  }

  onSliderNext() {
    this.sliderGoTo(1);
  }

  setSelectionBoxSize() {
    const firstNavItemEl = this.firstNavItemEl.current;

    if (firstNavItemEl !== null) {
      this.setState({
        selectionBoxSize: {
          w: firstNavItemEl.offsetWidth,
          h: firstNavItemEl.offsetHeight,
        },
      });
    }
  }

  updateSelectionBoxLeft = (event, ix) => {
    const el = event.currentTarget;
    this.setState({
      selectionBoxLeft: el.offsetLeft,
      selectionIndex: ix,
    });
  };

  debounce(func, wait, immediate) {
    let timeout;

    return function () {
      const context = this;
      const args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  render() {
    const {
      t,
      activePart,
      nitrumOpen,
      backgroundVisible,
      openDrawer,
      closeDrawer,
      openNitrum,
      toggleBackground,
      buildConfigCode,
    } = this.props;

    const {
      sliderPrevActive,
      sliderNextActive,
      selectionBoxLeft,
      selectionBoxSize,
      selectionBoxImmediateTranslation,
    } = this.state;

    const items = parts.map((part, ix) => {
      const label = t(`parts:${part.id}._part_name`);
      const active = part.id === activePart;

      return (
        <li
          ref={ix === 0 ? this.firstNavItemEl : null}
          key={part.id}
          className={active ? "active" : ""}
          data-interact="category"
          data-item={part.id}
          onClick={(e) => {
            this.updateSelectionBoxLeft(e, ix);
            active ? closeDrawer() : openDrawer(part.id);
          }}
        >
          <img src={active ? part.activeIcon : part.icon} alt={label} />
          <div className="label">{label}</div>
          <div className="outline"></div>
        </li>
      );
    });

    return (
      <div className={`app-nav ${nitrumOpen ? "hide" : ""}`}>
        <div className="action-item action-item-desktop">
          <div className="action-item-inner">
            <button
              data-interact="cta"
              data-item="outside-view"
              className="btn btn-lg btn-secondary"
              onClick={() => toggleBackground()}
              title={t("outside_view")}
            >
              {t("outside_view")}
            </button>
            <button
              data-interact="cta"
              data-item="3d-view"
              className={`btn btn-lg btn-secondary btn-overlay ${
                backgroundVisible ? "active" : ""
              }`}
              onClick={() => toggleBackground()}
              title={t("3d_view")}
            >
              {t("3d_view")}
            </button>
            <button
              className={`btn btn-lg btn-secondary btn-overlay ${
                activePart !== null ? "active" : ""
              }`}
              onClick={() => closeDrawer()}
              title={t("full_view")}
            >
              {t("full_view")}
            </button>
          </div>
        </div>
        <div className="parts-wrapper">
          <div
            ref={this.sliderEl}
            className="scrollable"
            onScroll={this.updateSliderControls.bind(this)}
          >
            <ul className="parts-nav">{items}</ul>
            <div
              className={`selection-box ${
                activePart !== null ? "active" : ""
              } ${
                selectionBoxImmediateTranslation ? "immediate-translation" : ""
              }`}
              style={{
                width: selectionBoxSize.w,
                height: selectionBoxSize.h,
                transform: `translateX(${selectionBoxLeft}px)`,
              }}
            ></div>
          </div>
          <div
            className={`prev ${sliderPrevActive ? "active" : ""}`}
            onClick={this.onSliderPrev.bind(this)}
          >
            <IconCaret />
          </div>
          <div
            className={`next ${sliderNextActive ? "active" : ""}`}
            onClick={this.onSliderNext.bind(this)}
          >
            <IconCaret />
          </div>
        </div>
        <div className="action-items-row-mobile">
          <div className="action-item action-item-mobile">
            <button
              className="btn btn-circle"
              onClick={() => toggleBackground()}
            >
              <IconEnvironment />
            </button>
          </div>
          <div className="action-item">
            <button
              className="btn btn-primary btn-lg btn-icon btn-icon-right"
              data-interact="cta"
              data-item="summary"
              onClick={() => {
                buildConfigCode();
                openNitrum();
              }}
            >
              {t("summary")}
              <IconCaret className="icon icon-right" />
            </button>
          </div>
          <div className="action-item action-item-mobile">
            {/* <ArButton /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(["common", "parts"])(
  connect(mapState, mapDispatch)(Nav)
);
